// Translated tarifs (pricing) data for Tarifs page
export const getTarifsData = (language = 'fr') => {
  const data = {
    fr: {
      betonTypes: [
        {
          name: "Béton Imprimé",
          description: "Aspect pierre naturelle, nombreux motifs disponibles",
          icon: "🏛️"
        },
        {
          name: "Béton Désactivé",
          description: "Surface granulat apparent, aspect naturel",
          icon: "🌿"
        },
        {
          name: "Béton Balé",
          description: "Finition striée, excellent pour extérieur",
          icon: "🌊"
        },
        {
          name: "Béton Lissé",
          description: "Surface lisse et moderne",
          icon: "✨"
        },
        {
          name: "Béton Ciré",
          description: "Finition haut de gamme pour intérieur/extérieur",
          icon: "💎"
        }
      ],
      prixTiers: [
        { range: "0 - 40 m²", prix: "149€/m²", label: "Tarif Standard" },
        { range: "41 - 70 m²", prix: "113€/m²", label: "Tarif Réduit" },
        { range: "71 - 150 m²", prix: "88€/m²", label: "Tarif Moyen Volume" },
        { range: "151 m² et plus", prix: "73€/m²", label: "Tarif Grand Volume" }
      ]
    },
    en: {
      betonTypes: [
        {
          name: "Stamped Concrete",
          description: "Natural stone appearance, many patterns available",
          icon: "🏛️"
        },
        {
          name: "Exposed Aggregate Concrete",
          description: "Visible aggregate surface, natural look",
          icon: "🌿"
        },
        {
          name: "Brushed Concrete",
          description: "Ridged finish, excellent for outdoors",
          icon: "🌊"
        },
        {
          name: "Polished Concrete",
          description: "Smooth and modern surface",
          icon: "✨"
        },
        {
          name: "Waxed Concrete",
          description: "High-end finish for indoor/outdoor",
          icon: "💎"
        }
      ],
      prixTiers: [
        { range: "0 - 40 m²", prix: "149€/m²", label: "Standard Rate" },
        { range: "41 - 70 m²", prix: "113€/m²", label: "Reduced Rate" },
        { range: "71 - 150 m²", prix: "88€/m²", label: "Medium Volume Rate" },
        { range: "151 m² and above", prix: "73€/m²", label: "Large Volume Rate" }
      ]
    }
  };

  return data[language] || data.fr;
};
